import { AdminUsersHeader, AdminUsersList } from 'components/Admin';
import { Grid } from 'components/UI/Grid';
import { Suspend } from 'components/UI/Suspend';
import { useAdminUsersList, useLicenseModels } from 'hooks/store';

export function AdminUsersPage() {
	const [{ data: users, loading: loadingUsers, fetched }] = useAdminUsersList();
	const [{ loading: loadingLicenseModels }] = useLicenseModels();

	return (
		<>
			<AdminUsersHeader />

			<Suspend loading={loadingUsers || loadingLicenseModels} immediate={!fetched}>
				<Grid.Container>
					<AdminUsersList users={users} />
				</Grid.Container>
			</Suspend>
		</>
	);
}
